import { createSelector } from 'reselect';
import { getSelectedNotification } from '../../../PowertrainOverview/Header/NotificationDropdown/selectors';
import { getAssets, isCIAMSyncFlag, isRefreshAssets } from '../../../GeneralFilter/GeneralFilterModal/selectors';

export const getAssetOverviewList = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.data;
};

const getAssetOverviewLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.loadingStatus;
};

const getPageNumber = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.pageNumber;
};

const getHasMore = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.hasMore;
};
const getShowThreshold = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.showThreshold;
};
const getShowTrend = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.showTrend;
};
const getInitialLoadDone = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.initialLoadDone;
};
const getSelectedAsset = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.selectedAsset;
};

export const getModel = createSelector(
    [
        getAssetOverviewList,
        getAssetOverviewLoadingStatus,
        getPageNumber,
        getShowThreshold,
        getShowTrend,
        getHasMore,
        getInitialLoadDone,
        getSelectedNotification,
        getSelectedAsset,
        getAssets,
        isCIAMSyncFlag,
        isRefreshAssets
    ],
    (
        assetOverviewList,
        assetOverviewLoadingStatus,
        pageNumber,
        showThreshold,
        showTrend,
        hasMore,
        initialLoadDone,
        selectedNotification,
        selectedAsset,
        overviewAssetList,
        refeshCIAMSync,
        refreshAssets
    ) => {
        return {
            assetOverviewList,
            assetOverviewLoadingStatus,
            pageNumber,
            showThreshold,
            showTrend,
            hasMore,
            initialLoadDone,
            selectedNotification,
            selectedAsset,
            overviewAssetList,
            refeshCIAMSync,
            refreshAssets
        };
    }
);
